import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';

/**
 * Address will render a formatted presentation of an HTML Address element using supplied location data.
 *
 */
function Address(_ref) {
  let {
    location,
    inline = false,
    ...rest
  } = _ref;
  const {
    address1,
    address2,
    city,
    state,
    zip
  } = location;
  const lineClasses = clsx({
    'display-block': !inline
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "address"
  }, rest), address1 && /*#__PURE__*/_jsx("span", {
    className: lineClasses
  }, void 0, address1, inline && ', '), address2 && /*#__PURE__*/_jsx("span", {
    className: lineClasses
  }, void 0, address2, inline && ', '), /*#__PURE__*/_jsx("span", {
    className: lineClasses
  }, void 0, city, ",", ' ', state, ' ', zip));
}
export default Address;